import React, { ReactNode } from 'react';

import {
  Box,
  createStyles,
  FormControl,
  makeStyles,
  TextField,
} from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      display: 'flex',
      flexDirection: 'row',
    },
    inputBox: {
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      width: '100%',
    },
    inputLabel: {
      flex: '0 0 25%',
      height: '30px',
      lineHeight: '30px',
      display: 'inline-block',
    },
    inputElement: {
      flex: '1 1 auto',
    },
    inputElementInput: {
      height: '30px',
    },
    withIcon: {
      marginRight: '40px',
    },
    textBefore: props =>
      'textBefore' in props
        ? {
            '&::before': {
              content: `"${props.textBefore}"`,
              textWrapMode: 'nowrap',
              paddingBottom: '4px',

              color: 'gray',
            },
            '& input': {
              paddingLeft: '70px',
            },
          }
        : {},
  }),
);

export const TextInput = ({
  id,
  value,
  name,
  onChange,
  helperText,
  type,
  required,
  disabled,
  error,
  textBefore,
  icon,
}: {
  id: string;
  value: string | number | null;
  name: string;
  onChange: (value: any) => void;
  helperText?: string | ReactNode;
  type?: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  textBefore?: string | null;
  icon?: ReactNode;
}) => {
  const classes = useStyles({ textBefore: textBefore || '' });
  return (
    <FormControl fullWidth className={classes.formControl}>
      <Box className={classes.inputBox}>
        <TextField
          id={id}
          type={type}
          name={name}
          label="Name"
          className={classes.inputElement}
          required={required}
          disabled={disabled}
          error={error}
          value={value}
          size="medium"
          InputLabelProps={{
            shrink: true,
          }}
          onChange={onChange}
          onBlur={onChange}
          variant="standard"
          InputProps={{
            className: `${classes.inputElementInput} ${
              textBefore ? classes.textBefore : null
            } ${icon ? classes.withIcon : null}`,
          }}
          FormHelperTextProps={{
            disabled: false,
          }}
          helperText={disabled ? '' : helperText}
        />
        {!!icon && icon}
      </Box>
    </FormControl>
  );
};
